import { LANGUAGE } from "../actionTypes";

const langActionn = (value) => {
    return {
        type: LANGUAGE,
        data: value
    };
}

export { langActionn };